<template>
  <div class="dvSectionNav">
    <div class="dvTabs">

      <div
        :class="{ isActive: this.$route.params.status == 'valid' ? true : false }"
        @click="filterByReferralStatus('valid')"
        class="waves-effect waves-light dvTabs-item isValid">
        Valid<div class="dvTabs-tally">{{ referralSummary.valid }}</div>
      </div>

      <div
        :class="{ isActive: this.$route.params.status == 'pending' ? true : false }"
        @click="filterByReferralStatus('pending')"
        class="waves-effect waves-light dvTabs-item isPending">
        Pending<div class="dvTabs-tally">{{ referralSummary.pending }}</div>
      </div>

      <div
        :class="{ isActive: this.$route.params.status == 'expiring' ? true : false }"
        @click="filterByReferralStatus('expiring')"
        class="waves-effect waves-light dvTabs-item isExpiring">
        Expiring<div class="dvTabs-tally">{{ referralSummary.expiring }}</div>
      </div>

      <div
        :class="{ isActive: this.$route.params.status == 'archive' ? true : false }"
        @click="filterByReferralStatus('archive')"
        class="waves-effect waves-light dvTabs-item isArchive">
        Archive<div class="dvTabs-tally">{{ referralSummary.archive }}</div>
      </div>

    </div> <!-- dvTabs -->

    <div class="dvSectionNav-link valign-wrapper">
      <router-link v-if="showAddNew"
        class="waves-effect waves-light btn btn-Action flexCenterAll"
        :to="{ name:'referrals_add_new' }">
        <span class="icon-action_add_circle"></span><div>Add Client</div>
      </router-link>
    </div> <!-- dvSectionNav-link -->
  </div> <!-- dvSectionNav -->
</template>

<script>
  export default {
    name: 'referrals-nav',
    props: ['referralSummary', 'showAddNew'],
    watch:{
      refreshImport (newPage, oldPage) {
        
        let allowedPages = [ 'referrals_client_view', 'referrals_add_new', 'referral_status' ]
        let res = newPage.split(':');
        if(allowedPages.indexOf(res[0]) >= 0){
          this.$emit('refreshPage');
        }
      }
    },
    computed: {
      refreshImport  (){
        return this.$store.getters.getRefreshPage();
      }
    },
    methods: {
      filterByReferralStatus: function(valid){
        this.$emit('filterByReferralStatus', valid);
      }
    }
  }

  // export default {
  //   name: 'referrals-nav',
  //   data: () => ({
  //   }),
  //   computed: {
  //   },
  //   methods: {
  //   },
  //   mounted() {
  //   },
  //   components: {
  //   }
  // }
</script>
